import { Position, State } from 'src/types'

export const useModelSelector = (
  state: State,
  urlParams: string[]
): {
  position: Position
  isReset: boolean
} => {
  const positionIndex = urlParams.length - 1
  const isYouthModel = urlParams[urlParams.length - 2] === 'youth'
  const position = urlParams[positionIndex] === 'simulation' || isYouthModel ? state?.baseModel?.position : (urlParams[positionIndex] as Position)
  const isReset = state.baseModel?.productNumber === ''
  return { position, isReset }
}
